import { Button, ClassName, Tray } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { t } from 'i18next';
import { FunctionComponent } from 'react';

export interface ICertificationsConfirmationFormProps {
  onConfirm: () => void;
  className?: ClassName;
}

const CertificationsConfirmationForm: FunctionComponent<ICertificationsConfirmationFormProps> = (props) => {
  const { className, onConfirm } = props;

  const classes = classNames('certifications-confirmation-form mx-8 mb-6', className);

  return (
    <div className={classes}>
      <div>
        <div>{t('Someone will be reaching out to you shortly about getting our new operations module turned on.')}</div>
        <div className={'mt-4'}>{t('Thank you!')}</div>
      </div>
      <Tray align="right">
        <Button onClick={onConfirm} type="primary" className={'mt-4'}>
          {t('OK')}
        </Button>
      </Tray>
    </div>
  );
};

export default CertificationsConfirmationForm;
